import React, { useContext, useEffect } from 'react';
import { UserContext } from '../context/UserContext';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import './Profile.css';
import apiConfig from '../config/apiConfig';
import { getAlignmentTitle, getAlignmentColor, calculateAlignmentValue } from '../data/alignmentTitles';

const Profile = () => {
  const { user } = useContext(UserContext);
  
  // Move this useEffect above all conditional returns 
  useEffect(() => {
    // Only execute the logging if playerCharacter exists
    if (user?.playerCharacter) {
      console.log('Profile character data updated:', {
        good: user.playerCharacter?.good,
        neutral: user.playerCharacter?.neutral,
        evil: user.playerCharacter?.evil,
        calculated: user.playerCharacter ? calculateAlignmentValue(
          user.playerCharacter.good || 0, 
          user.playerCharacter.neutral || 0, 
          user.playerCharacter.evil || 0
        ) : null,
        title: user.playerCharacter ? getAlignmentTitle(calculateAlignmentValue(
          user.playerCharacter.good || 0, 
          user.playerCharacter.neutral || 0, 
          user.playerCharacter.evil || 0
        )) : null
      });
    }
  }, [user?.playerCharacter]);

  if (!user || !user.playerCharacter) {
    return (
      <div className="page-content">
        <h2>No Profile Data</h2>
      </div>
    );
  }

  const { playerCharacter } = user;
  const createdAt = new Date(playerCharacter.createdAt);
  const now = new Date();
  const ageInDays = Math.floor((now - createdAt) / (1000 * 60 * 60 * 24));

  // Get alignment title and color from our alignment system
  const alignmentValue = calculateAlignmentValue(
    playerCharacter.good || 0, 
    playerCharacter.neutral || 0, 
    playerCharacter.evil || 0
  );
  const alignmentTitle = getAlignmentTitle(alignmentValue);
  const alignmentColor = getAlignmentColor(alignmentValue);

  // Add this debugging inside the component
  console.log('Profile alignment calc:', {
    good: playerCharacter.good,
    neutral: playerCharacter.neutral,
    evil: playerCharacter.evil,
    calculated: alignmentValue,
    title: alignmentTitle
  });

  // Replace our custom color markup with HTML for markdown rendering.
  const formattedBio = playerCharacter.bio.replace(
    /\[color=([#a-zA-Z0-9]+)\](.*?)\[\/color\]/g,
    '<span style="color:$1">$2</span>'
  );

  // Make sure to include the return statement with the JSX for rendering
  return (
    <div className="page-content profile-page">
      <div className="profile-header">
        <div className="profile-picture">
          {playerCharacter.icon ? (
            <img 
              src={`${apiConfig.resources}${playerCharacter.icon}`} 
              alt="Character Icon" 
            />
          ) : (
            <div className="no-image">No User Image</div>
          )}
        </div>
        <div className="profile-details">
          <h2>
            {playerCharacter.username} {playerCharacter.level !== undefined && `(${playerCharacter.level})`}
          </h2>
          <p><strong>Gold:</strong> {playerCharacter.gold}</p>
          <p><strong>Alignment:</strong> <span style={{ color: alignmentColor }}>{alignmentTitle}</span></p>
          <p><strong>Player Age:</strong> {ageInDays} days old</p>
          <div className="profile-edit">
            <Link to="/edit-profile" className="action-button">Edit Profile</Link>
          </div>
        </div>
      </div>
      <div className="profile-bio">
        <h3>Bio</h3>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>
          {formattedBio}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default Profile;
